import { I as t } from "../../constants-DeVuDy8J.js";
import { createElementBlock as d, openBlock as i, normalizeClass as o, createElementVNode as r } from "vue";
import { _ as n } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const s = {
  name: "DtIconFolders",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (a) => Object.keys(t).includes(a)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return t[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, c = ["aria-label", "data-qa", "aria-hidden"], _ = /* @__PURE__ */ r("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M2.94 1.94A1.5 1.5 0 0 1 4 1.5h1.968a1.5 1.5 0 0 1 1.242.671l.413.604A.5.5 0 0 0 8.037 3H10a1.5 1.5 0 0 1 1.5 1.5v3A1.5 1.5 0 0 1 10 9H4c-.826 0-1.5-.674-1.5-1.5V3c0-.398.158-.78.44-1.06ZM4 2.5a.5.5 0 0 0-.5.5v4.5c0 .274.226.5.5.5h6a.5.5 0 0 0 .5-.5v-3A.5.5 0 0 0 10 4H8.032a1.5 1.5 0 0 1-1.242-.671l-.413-.604a.5.5 0 0 0-.414-.225H4Z",
  fill: "currentColor"
}, null, -1), u = /* @__PURE__ */ r("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M1 3.5a.5.5 0 0 1 .5.5v5.5c0 .274.226.5.5.5h7a.5.5 0 0 1 0 1H2c-.826 0-1.5-.674-1.5-1.5V4a.5.5 0 0 1 .5-.5Z",
  fill: "currentColor"
}, null, -1), f = [
  _,
  u
];
function h(a, m, l, p, v, e) {
  return i(), d("svg", {
    "aria-label": l.ariaLabel,
    class: o([e.iconSizeClass, "d-icon d-icon--folders"]),
    "data-qa": e.dataQA,
    "aria-hidden": e.ariaHidden,
    role: "img",
    "data-name": "Folders",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, f, 10, c);
}
const A = /* @__PURE__ */ n(s, [["render", h]]);
export {
  A as default
};
//# sourceMappingURL=folders.js.map
